import State from '../interfaces/states/State';

const userExplorerDataEvents$ = (state: State): any[] => state.userExplorer.userExplorerData.data.event;

export default userExplorerDataEvents$;
